import Dialog from '../1. Core/Controls/Dialog/Dialog';
import Select from '../1. Core/Controls/Select/Select';
import {ServerAPI} from '../1. Core/ServerAPI';
import NP from '../1. Core/NP';

interface FighterCardV2CatalogRow {
	catalogId: number;
	fullName: string;
	displayOrder: number;
	isChampion: boolean;
	owned: boolean;
	weightClassKey: string;
	isSpecial?: boolean;
}

export default class GrantFighterCardV2Dialog extends Dialog {
	private _UserId: number;
	private _weightSelect: Select;
	private _fighterSelect: Select;

	constructor(props: { UserId: number; EvOkButtonClick?: () => void }) {
		super(props);
	}

	_initFields(settings: { UserId: number; EvOkButtonClick?: () => void }) {
		this._UserId = settings.UserId;
		super._initFields(settings);
		this._Caption = 'Fighter card v2';
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save';
		this._AutoDestroy = true;
		this._Width = 420;
		this._Height = 360;
	}

	_render() {
		super._render();

		this._weightSelect = new Select({
			FloatingLabel: 'Weight class',
			ParentNode: this._contentNode,
			EvItemSelected: () => this.loadFighters(),
		});

		this._fighterSelect = new Select({
			FloatingLabel: 'Fighter',
			ParentNode: this._contentNode,
		});

		this.reloadWeights();
	}

	async reloadWeights() {
		const weights = await ServerAPI.get<string[]>('/fighter-cards/v2/weight-classes');
		const prev = this._weightSelect.getValue();
		const items = (weights || []).map(w => ({Content: w, Value: w}));
		this._weightSelect.setItems(items);
		if (!items.length) {
			this._fighterSelect.setItems([]);
			return;
		}
		const next = items.some(i => i.Value === prev) ? prev : items[0].Value;
		this._weightSelect.setValue(next, false);
		this.loadFighters();
	}

	async loadFighters() {
		const weight = this._weightSelect.getValue();
		if (!weight) {
			this._fighterSelect.setItems([]);
			return;
		}
		const rows = await ServerAPI.get<FighterCardV2CatalogRow[]>(
			`/fighter-cards/v2/catalog?weightClassKey=${encodeURIComponent(weight)}&userId=${this._UserId}`,
		);
		this._fighterSelect.setItems(
			rows.map(r => ({
				Content: `${r.displayOrder}. ${r.fullName}${r.isSpecial ? ' (special)' : ''}${r.isChampion ? ' (champion)' : ''}${r.owned ? ' — owned' : ''}`,
				Value: r.catalogId,
				Data: r,
			})),
		);
	}

	async _onOkButtonClick() {
		const row = this._fighterSelect.getSelectedItem()?.Data as FighterCardV2CatalogRow | undefined;
		const catalogId = this._fighterSelect.getValue();
		if (!catalogId) {
			return;
		}
		if (row?.owned) {
			NP.showMessage({Content: 'Card already owned by user'});
			return;
		}
		const granted = await ServerAPI.post<boolean>(
			`/fighter-cards/v2/grant/${this._UserId}?catalogId=${catalogId}`,
		);
		if (!granted) {
			NP.showMessage({Content: 'Could not grant card (not found or already owned)'});
			return;
		}
		this.EvOkButtonClick.fire(this);
		this.hide();
	}
}

